// TODO: Remove cyclic dependency
/* eslint-disable-next-line import/no-cycle */

import type { IViewCoverage } from "./IViewCoverage";
import { StreamSplitType } from "./StreamSplitType";
import { StreamSplitTypeFunctions } from "./StreamSplitTypeFunctions";

export class ViewCoverageFunctions {
    public static enhanceViewCoverage(vc: IViewCoverage): IViewCoverage {
        vc.streamSplitName = vc.streamSplitType as any;
        vc.streamSplitType = StreamSplitType[vc.streamSplitName as keyof typeof StreamSplitType];
        vc.streamSplitIcon = StreamSplitTypeFunctions.streamSplitTypeIcon(vc.streamSplitType);
        return vc;
    }
}
